import { wrapFetch } from '../libs/fetch';
import type { Followers, IsFollowed, FollowedCompanyIds } from '../types/personCompanyRelationship';

export const getFollowedCompanyIds = async () => {
  return await wrapFetch<FollowedCompanyIds>('/api/v1/person_company_relationships');
};

export const getFollowers = async (companyId: number | string) => {
  return await wrapFetch<Followers>(`/api/v1/person_company_relationships/get_followers/?company_id=${companyId}`);
};

export const getIsFollowed = async (companyId: number | string) => {
  return await wrapFetch<IsFollowed>(`/api/v1/person_company_relationships/is_followed/?company_id=${companyId}`);
};

export const executeFollow = async ({ csrfToken, body }: { csrfToken: string; body: any }) => {
  await wrapFetch('/api/v1/person_company_relationships/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body,
  });
};

export const executeUnFollow = async ({ csrfToken, companyId }: { csrfToken: string; companyId: number | string }) => {
  await wrapFetch(`/api/v1/person_company_relationships/${companyId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify({ company_id: companyId }),
  });
};
